module.exports = __webpack_public_path__ + "static/media/scrap-car-pickup-goldcoast.e0681ec7.png";